import React from "react"

import Select from "react-select"
import { gql, useQuery } from "urql"

import { WithLoadingIndicator } from "~tailwindui/Basics"

import ordered from "src/ordered"

export type StudentSubjectsProps = {
  studentId: string
  subjectId: string
  onChange: (subject: { id: string }) => void
}

const StudentSubjects: React.FC<StudentSubjectsProps> = ({
  studentId,
  subjectId,
  onChange,
}) => {
  const [result] = useQuery({
    query: subjectsQuery,
    variables: { id: studentId },
  })

  return (
    <WithLoadingIndicator
      result={result}
      error="An error occurred while loading your subjects"
    >
      {({ data }) => (
        <Select
          options={ordered(data.student.subjects, "name")}
          onChange={onChange}
          defaultValue={
            subjectId
              ? data.student.subjects.find(s => s.id === subjectId)
              : null
          }
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
        />
      )}
    </WithLoadingIndicator>
  )
}

const subjectsQuery = gql`
  query StudentSubjects($id: ID!) {
    student(id: $id) {
      subjects {
        id
        name
      }
    }
  }
`

export default StudentSubjects
